import React from 'react';

function ClientStores(){
  return <div className="col-md-12">
    <h3>Магазины</h3>
  </div>
}

export default ClientStores
